<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove from the guarantee period {{hpgp.huis_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHpgp">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

export default {
  data() { 
    return {
      dialog: false,
      hpgp_encrid: null,
      hpgp: {},
    }
  },
  methods: {
    open(hpgp_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspt/hpgp/getHpgp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHpgp"
          },
          getHpgp: {
            hpgp_encrid: hpgp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hpgp = res.data.getHpgp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHpgp() { 
      this.$axios
        .post("ares/json/ares/huis/hspt/hpgp/rmHpgp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHpgp"
          },
          rmHpgp: {
            hpgp_encrid: this.hpgp.hpgp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            this.$emit('updateData')
            this.dialog = false;
          }
        })
    },
  }
}
</script>

